module.exports = __webpack_public_path__ + "img/12.956a5147.jpg";